module.exports = __webpack_public_path__ + "static/img/indexicon1.9406a90.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/indexicon1.png
// module id = JKhh
// module chunks = 1